/**
 * File track-module-viewed.js.
 * Handles firing Segment events when modules are viewed
 */

const modules = document.querySelectorAll('.module');
const moduleLocation = window.location.href;
let moduleObserverOptions = {
  threshold: [0.75]
};

let handleModuleView = (entries, observer) => {
  entries.forEach(entry => {
    const module = entry.target;

    if (module.offsetHeight == 0) {
      return;
    }

    const moduleName = module.getAttribute('data-name');
    const moduleIndex = module.getAttribute('data-index');
    let moduleHeader = module.querySelector('h1') || module.querySelector('h2') || null; 
    
    if (moduleHeader) {
      moduleHeader = moduleHeader.textContent
        .replace(/\n/g, '')
        .replace(/\s+/g,' ')
        .trim();
    }

    let properties = {
      module_location: moduleLocation,
      module_name: moduleName,
      module_index: moduleIndex,
      module_header: moduleHeader
    }

    if (entry.isIntersecting) {
      segment(
        'track',
        'Module Viewed',
        properties
      );

      moduleObserver.unobserve(module);
    }
  })
}

const moduleObserver = new IntersectionObserver(handleModuleView, moduleObserverOptions);

modules.forEach(module => {
  moduleObserver.observe(module);
});
